export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
export const EMAIL_PATTERN_STRING = '^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$';

export const E164_PHONE_PATTERN = /^\+[1-9]\d{6,14}$/;
export const PHONE_MAX_LENGTH = 16;
export const CONTACT_ROLE_MAX_LENGTH = 50;
export const CONTACT_PERSON_TEXT_MAX_LENGTH = 50;
export const CONTACT_PERSON_DESCRIPTION_MAX_LENGTH = 500;
export const DEFAULT_COUNTRY_PHONE_PREFIX = '+48';

export const sanitizePhoneNumber = (value: string) => {
    const trimmed = value.trim();
    const digits = trimmed.replace(/\D/g, '').slice(0, 15);

    if (!digits) {
        return '';
    }

    return `+${digits}`;
};

export const isEmailValid = (value: string) => value.trim().length === 0 || EMAIL_PATTERN.test(value.trim());

export const isPhoneNumberValid = (value: string) => value.trim().length === 0 || E164_PHONE_PATTERN.test(value.trim());
